module.exports = __webpack_public_path__ + "media/application/images/2018/header-lock-green-27b799f7869fc9dba288edf524b24719.svg";